module.exports = __webpack_public_path__ + "static/media/Gstore.5a9f2125.svg";